/**
 * True on tablets and phones, where the exam page being hidden means the
 * whole browser app went to the background (hardware back button, home,
 * app switcher) rather than the student switching desktop tabs. Touch-screen
 * laptops report a fine primary pointer, so they are not treated as touch
 * devices. iPadOS reports a desktop "MacIntel" platform, hence the extra check.
 */
export function isTouchDevice(): boolean {
  const hasCoarsePointer = window.matchMedia?.('(pointer: coarse)').matches ?? false;
  const isMobileUserAgent = /Android|iPhone|iPad|iPod|Mobile|Tablet/i.test(navigator.userAgent);
  const isIPadOs = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;

  return hasCoarsePointer || isMobileUserAgent || isIPadOs;
}
